import { Injectable } from '@angular/core';

interface UploadedFile {
  name: string;
  size: number;
  file: File;
  status: 'pending' | 'success' | 'error';
  api?: string;
  csvHeaders?: string[];
  columnMapping?: ColumnMapping;
  needsMapping?: boolean;
  detectedEpsgCode?: number | null;
  selectedEpsgCode?: number | null;
  epsgRegion?: string | null;
  epsgDescription?: string | null;
  epsgError?: string | null;
  azimuthReference?: 'true_north' | 'grid_north'; // Azimuth reference system
}

interface ColumnMapping {
  MD: string;
  INC: string;
  AZI: string;
}

interface UploadResult {
  filename: string;
  api?: string;
  flag?: boolean;
  distance?: number;
  tolerance?: number;
  calculated_bh_x?: number;
  calculated_bh_y?: number;
  reference_bh_x?: number;
  reference_bh_y?: number;
  error?: string;
}

@Injectable({ providedIn: 'root' })
export class UploadStateService {
  uploadedFiles: UploadedFile[] = [];
  uploadResults: UploadResult[] = [];
  uploadError: string | null = null;
  toleranceThreshold: number | null = null;
  selectedEpsgCode: number = 32065;

  clearAll(): void {
    this.uploadedFiles = [];
    this.uploadResults = [];
    this.uploadError = null;
  }
}